import React from 'react';

import { InternalQuestion, useQuestionContext } from '../../../contexts';
import { Structure_structure_questionGroups_questions_options } from '../../../graphqlTypes';

export enum SelectType {
  single,
  multi,
  singleMulti,
}

export const useSelect = () => {
  const { questions, evalDisplayRule, activeQuestion } = useQuestionContext();

  const isSelected = (question: InternalQuestion, option: Structure_structure_questionGroups_questions_options) => {
    if (question.tempAnswer) {
      // If the question is answered then check if the code is included
      return question.tempAnswer?.map((a) => a.code)?.includes(option.code);
    }
    return option.default;
  };

  const goToNext = ({
    questionType,
    isEditing,
    noIssuesIsSelected,
    questionOptions,
    touched,
    onNext,
  }: {
    questionType: any;
    isEditing: boolean;
    noIssuesIsSelected?: boolean;
    questionOptions: any;
    touched?: boolean;
    onNext: any;
  }) => {
    const shouldShowNewQuestion = () => {
      let lastVisible: InternalQuestion;
      questions?.forEach((q) => {
        q.visible = evalDisplayRule(q);
        if (q.visible) {
          lastVisible = q;
        } // Save last visible question
      });
      if (lastVisible?.key !== activeQuestion.key) {
        return true;
      }

      return false;
    };

    if (questionType === SelectType.single || (questionType === SelectType.singleMulti && noIssuesIsSelected)) {
      if (isEditing) {
        // We don't want to go to the next if it is editing
        return;
      }

      if ((touched && !shouldShowNewQuestion()) || (!isEditing && questionOptions?.length === 1)) {
        onNext();
      }
    }
  };

  const normalizeColor = (extra?: string[]) => {
    if (!extra || extra.length <= 0) {
      return;
    }

    return `${extra[0].includes('#') ? '' : '#'}${extra[0]}`;
  };

  const createRadioItems = (question: InternalQuestion, type: SelectType, itemSubtitle: any, ColorPreview: any) =>
    question.options?.map((o, index) => {
      let isSingle: boolean;
      switch (type) {
        case SelectType.single:
          isSingle = true;
          break;
        case SelectType.singleMulti:
          isSingle = index === 0;
          break;
        default:
          isSingle = false;
          break;
      }

      return {
        title: o.value,
        subtitle: o.default ? itemSubtitle : '',
        value: o,
        single: isSingle,
        leftView: o.extra ? <ColorPreview hex={normalizeColor(o.extra)} /> : undefined,
        selected: isSelected(question, o),
      };
    });

  return { goToNext, createRadioItems };
};
